import { render, staticRenderFns } from "./WirteOffNew.vue?vue&type=template&id=331039f6&"
import script from "./WirteOffNew.vue?vue&type=script&lang=js&"
export * from "./WirteOffNew.vue?vue&type=script&lang=js&"
import style1 from "./WirteOffNew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports